import { render, staticRenderFns } from "./B_bind.vue?vue&type=template&id=9ebd5a9e&scoped=true&"
import script from "./B_bind.vue?vue&type=script&lang=js&"
export * from "./B_bind.vue?vue&type=script&lang=js&"
import style0 from "./B_bind.vue?vue&type=style&index=0&id=9ebd5a9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ebd5a9e",
  null
  
)

export default component.exports